namespace GeniuzPOS.QRreport {
    export enum Qty_AmtFg {
        Qty_AmtFg0 = 0,
        Qty_AmtFg1 = 1,
        Qty_AmtFg2 = 2
    }
    Serenity.Decorators.registerEnumType(Qty_AmtFg, 'GeniuzPOS.QRreport.Qty_AmtFg');
}
